(() => {
  if (customElements.get('navraee-size-calculator')) return;

  const roundSizes = [
    { label: '2-4', diameter: 2.25 },
    { label: '2-6', diameter: 2.35 },
    { label: '2-8', diameter: 2.5 },
    { label: '2-10', diameter: 2.625 }
  ];

  function calculate(wrist, unit) {
    if (typeof wrist !== 'number' || !Number.isFinite(wrist) || wrist <= 0) return null;
    const inches = unit === 'cm' ? wrist / 2.54 : wrist;
    const diameter = inches / Math.PI;
    if (!Number.isFinite(inches * 2.54) || !Number.isFinite(diameter * 25.4)) return null;
    const reference = roundSizes.find(size => size.diameter + 1e-9 >= diameter);
    const displayedDiameter = Math.ceil((diameter - 1e-9) * 1000) / 1000;
    if (!Number.isFinite(displayedDiameter)) return null;
    return { inches, centimeters: inches * 2.54, diameter, displayedDiameter, reference: reference ? reference.label : null, referenceDiameter: reference ? reference.diameter : null };
  }

  class NavraeeSizeCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.input = this.form.elements.wrist;
      this.unit = this.form.elements.unit;
      this.previousUnit = this.unit.value;
      this.result = this.querySelector('[data-result]');
      this.error = this.querySelector('[data-error-message]');
      this.number = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      this.readingNumber = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        maximumFractionDigits: 10
      });
      this.sizeNumber = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3
      });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.render();
      });
      this.input.addEventListener('input', () => this.clear());
      this.unit.addEventListener('change', () => {
        const value = this.input.valueAsNumber;
        if (Number.isFinite(value) && value > 0) {
          const converted = this.previousUnit === 'in' ? value * 2.54 : value / 2.54;
          this.input.value = String(Number(converted.toFixed(10)));
        }
        this.previousUnit = this.unit.value;
        this.clear();
      });
    }

    clear() {
      this.result.hidden = true;
      this.error.hidden = true;
      this.error.textContent = '';
      this.input.removeAttribute('aria-invalid');
    }

    render() {
      this.clear();
      const measurement = calculate(this.input.valueAsNumber, this.unit.value);
      if (!measurement) {
        this.error.textContent = this.dataset.error;
        this.error.hidden = false;
        this.input.setAttribute('aria-invalid', 'true');
        this.input.focus();
        return;
      }
      const inches = this.readingNumber.format(measurement.inches);
      const centimeters = this.readingNumber.format(measurement.centimeters);
      this.querySelector('[data-reading]').textContent = `${inches} ${this.dataset.inch} / ${centimeters} ${this.dataset.centimeter}`;
      this.querySelector('[data-diameter]').textContent = `${this.readingNumber.format(measurement.displayedDiameter)} ${this.dataset.inch} / ${this.number.format(measurement.diameter * 25.4)} ${this.dataset.millimeter}`;
      this.querySelector('[data-size]').textContent = measurement.reference ? `${measurement.reference} / ${this.sizeNumber.format(measurement.referenceDiameter)} ${this.dataset.inch}` : this.dataset.outside;
      this.result.toggleAttribute('data-has-reference', Boolean(measurement.reference));
      const message = this.dataset.share.replace('[inches]', inches).replace('[centimeters]', centimeters);
      this.querySelector('[data-share-link]').href = `https://wa.me/919650536800?text=${encodeURIComponent(message)}`;
      this.result.hidden = false;
    }
  }

  customElements.define('navraee-size-calculator', NavraeeSizeCalculator);
})();
